import React, { Component } from 'react'

// Components
import NewsletterForm from './NewsletterForm'

// Constants
import { LINKS, LOCATIONS_FIRST, LOCATIONS_SECOND, OTHERS, CONNECT_US } from './constants'

// Styles
import './index.scss'

class Footer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      checked: false,
    }
  }

  updateState = (obj) => {
    this.setState(obj)
  }

  render = () => {
    return (
      <footer>
        <div className="container">
          <div className="flex lg-col-flex xlg-flex-wrap">

            <div className="newsletter">
              <label className="e-label black" style={{ textAlign: 'center' }}>newsletter</label>
              <NewsletterForm checked={this.state.checked} updateState={this.updateState} />
            </div>

            <div className="links flex lg-col-flex xlg-flex-wrap">
              <div>
                <label className="e-label black">sitemap</label>
                <ul>
                  {
                    LINKS.map((item, i) => {
                      return (
                        <li key={`links${i}`}>
                          <a href={item.link}>
                            {item.title}
                          </a>
                        </li>
                      )
                    })
                  }
                </ul>
              </div>

              <div>
                <label className="e-label black">Others</label>
                <ul>
                  {
                    OTHERS.map((item, i) => {
                      return (
                        <li key={`others${i}`}>
                          <a href={item.link}>
                            {item.title}
                          </a>
                        </li>
                      )
                    })
                  }
                </ul>
              </div>

              <div className="locations">
                <label className="e-label black">locations</label>
                <div className="flex inner lg-col-flex xlg-flex-wrap">
                  <ul>
                    {
                      LOCATIONS_FIRST.map((item, i) => {
                        return (
                          <li key={`locations${i}`}>
                            <p>
                              {item.title}
                            </p>
                          </li>
                        )
                      })
                    }
                  </ul>

                  <ul>
                    {
                      LOCATIONS_SECOND.map((item, i) => {
                        return (
                          <li key={`locations${i}`}>
                            <p>
                              {item.title}
                            </p>
                          </li>
                        )
                      })
                    }
                  </ul>

                </div>

                <label className="e-label black" style={{ marginTop: '0.5rem' }}>connect with us</label>
                <ul className="connect-us flex">
                  {
                    CONNECT_US.map((item, i) => {
                      return <li key={`connect${i}`}>
                        <a href={item.link} target="_blank" rel="noopener noreferrer">{item.logo}</a>
                      </li>
                    })
                  }
                </ul>


              </div>
            </div>


          </div>


        </div>
      </footer>
    )
  }
}

export default Footer